// Names and URLs in one place. The product is "Penfold Says"; the score
// itself keeps the name "Beer Garden Index".

export const APP_NAME = 'Penfold Says';
export const SCORE_NAME = 'Beer Garden Index';
export const TAGLINE = 'Should you sit outside? Every UK pub garden, scored hour by hour.';

/** Production site (custom domain on Netlify). */
export const SITE_URL = 'https://nibley.online';

/**
 * Where share links point. Production and the main netlify.app site share
 * links to nibley.online; local dev and Netlify deploy/branch previews
 * (hostnames with "--") link to themselves so previews stay testable.
 */
export function shareOrigin(location: Pick<Location, 'hostname' | 'origin'> = window.location) {
  const local = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
  return local || location.hostname.includes('--') ? location.origin : SITE_URL;
}
